"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _fonts = require("../../styles/fonts");
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _excluded = ["icon", "size", "label", "testId", "testIdName"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SIZE = {
  xs: {
    height: '14px',
    fontSize: _fonts.fontSizes.s11,
    borderRadius: '2px',
    lineHeight: '14px'
  },
  sm: {
    height: '20px',
    fontSize: _fonts.fontSizes.s12,
    borderRadius: '2px',
    lineHeight: '20px'
  }
};
var HBBadgeBase = function HBBadgeBase(_ref) {
  var Icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    label = _ref.label,
    testId = _ref.testId,
    testIdName = _ref.testIdName,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'badge',
    componentName: 'HBBadgeBase'
  });
  return /*#__PURE__*/_react["default"].createElement(Badge, (0, _extends2["default"])({
    size: size
  }, props, {
    "data-testid": finalTestId
  }), Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
    color: props.color
  }), label);
};
var _default = exports["default"] = HBBadgeBase;
var getBorderStyles = function getBorderStyles(_ref2) {
  var border = _ref2.border,
    borderRadius = _ref2.borderRadius;
  return (0, _styledComponents.css)(["&::before{content:'';position:absolute;inset:0;border-radius:", ";padding:1px;background:", ";-webkit-mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);-webkit-mask-composite:destination-out;mask-composite:exclude;}"], borderRadius, border);
};
var Badge = _styledComponents["default"].div.withConfig({
  displayName: "HBBadgeBase__Badge",
  componentId: "sc-46fqmc-0"
})(["", " background:", ";color:", ";display:inline-flex;align-items:center;padding:0 ", ";gap:", ";font-family:", ";font-weight:600;position:relative;", ""], function (props) {
  return SIZE[props.size];
}, function (props) {
  return props.bg;
}, function (props) {
  return props.color;
}, _spacing["default"][4], _spacing["default"][4], _fonts.proximaNova, function (props) {
  return props.border && getBorderStyles({
    border: props.border,
    borderRadius: SIZE[props.size].borderRadius
  });
});
//# sourceMappingURL=HBBadgeBase.js.map